<template>
  <el-dialog
    :visible.sync="formVisible"
    title="收款信息"
    width="560px"
    @close="handleClose"
  >
    <div class="receipt-list" v-if="voucherList.length > 0">
      <div v-for="(item, idx) in voucherList" :key="idx" class="receipt-item">
        <span class="label">凭证：</span>
        <el-image v-if="item.payImg || item.imgUrl" class="receipt-img"
          style="width: 60px; height: 60px; flex-shrink: 0;" :src="item.payImg || item.imgUrl"
          :preview-src-list="[item.payImg || item.imgUrl]" />
        <div class="receipt-detail">
          <div>收款银行：{{ item.payBank || item.receivingBank || '-' }}</div>
          <div class="voucher-row">
            <div class="voucher-row-cell">支付单号：{{ item.payNum || item.paymentOrderNo || '-' }}</div>
            <div class="voucher-row-cell">付款金额：{{ formatAmount(item.payMoney || item.paymentAmount) }}</div>
          </div>
          <div>付款时间：{{ item.payTime || item.paymentTime || '-' }}</div>
        </div>
      </div>
    </div>
    <div v-else class="empty-tip">暂无收款信息</div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="formVisible = false">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      formVisible: false,
      voucherList: []
    }
  },
  methods: {
    handleCreate(row) {
      this.voucherList = this.getVoucherList(row)
      this.formVisible = true
    },
    handleClose() {
      this.voucherList = []
    },
    formatAmount(val) {
      if (val === null || val === undefined || val === '') return '-'
      const num = Number(val)
      return isNaN(num) ? val : num + '元'
    },
    getVoucherList(row) {
      if (!row) return []
      if (row.payVouchersList && row.payVouchersList.length > 0) {
        return row.payVouchersList
      }
      if (row.voucherList && row.voucherList.length > 0) {
        return row.voucherList
      }
      return []
    }
  }
}
</script>

<style lang="scss" scoped>
.receipt-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.receipt-item {
  display: flex;
  font-size: 14px;
  color: #6C6C6C;
  line-height: 14px;
  align-items: flex-start;
  background: #F8F8F8;
  padding: 20px;
  border-radius: 4px;

  .label {
    flex-shrink: 0;
    text-align: right;
  }
}

.receipt-img {
  margin-right: 12px;
  border-radius: 4px;
}

.receipt-detail {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .voucher-row {
    display: flex;

    .voucher-row-cell {
      flex: 1;
    }
  }
}

.empty-tip {
  text-align: center;
  color: #999;
  padding: 40px 0;
}
</style>
